import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, Button, Box, Typography } from '@mui/material';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

interface OrderQRCodeProps {
  orderId: string;
  orderCode?: string;
  isDelivered?: boolean;
}

export function OrderQRCode({ orderId, orderCode, isDelivered }: OrderQRCodeProps) {
  const [open, setOpen] = useState(false);
  const qrUrl = `${import.meta.env.VITE_API_BASE_URL}/orders/${orderId}/qrcode`;

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = qrUrl;
    link.download = `encomenda-${orderCode || orderId}-qrcode.png`;
    link.click();
  };

  const handleWhatsApp = () => {
    const text = encodeURIComponent(
      `Retire sua encomenda usando este QR Code: ${qrUrl}`
    );
    window.open(`https://wa.me/?text=${text}`, '_blank');
  };

  return (
    <>
      <Box display="flex" flexDirection="column" alignItems="center" my={3}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          startIcon={<QrCode2Icon sx={{ fontSize: 32 }} />}
          sx={{
            fontWeight: 700,
            fontSize: 20,
            borderRadius: 3,
            px: 5,
            py: 2,
            mb: 1,
            boxShadow: 2,
          }}
          onClick={() => setOpen(true)}
          disabled={isDelivered}
        >
          Visualizar QR Code de Retirada
        </Button>
        <Typography color="text.secondary" fontSize={15}>
          Clique para acessar o QR Code da sua encomenda
        </Typography>
      </Box>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs">
        <DialogTitle>QR Code para Retirada</DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img src={qrUrl} alt="QR Code" style={{ width: 220, height: 220, marginBottom: 16 }} />
          <Box display="flex" gap={2} mt={2}>
            <Button
              variant="outlined"
              startIcon={<FileDownloadIcon />}
              onClick={handleDownload}
              sx={{ fontWeight: 600, fontSize: 16, borderRadius: 2 }}
            >
              Baixar QR Code
            </Button>
            <Button
              variant="outlined"
              startIcon={<WhatsAppIcon />}
              onClick={handleWhatsApp}
              sx={{ fontWeight: 600, fontSize: 16, borderRadius: 2, color: '#25D366', borderColor: '#25D366' }}
            >
              Enviar por WhatsApp
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}